import { CalculatedVariable } from 'queries/features/types';

export const parseFeaturesTags = (data?: CalculatedVariable[]): ChartTag[] => {
  return (
    data?.map((tag) => ({
      name: tag.calculated_variable,
      reference: tag.calculated_variable,
      unit_of_measurement: tag.unit,
      category: [],
      isPlottable: true,
    })) ?? []
  );
};
